<ngx-zero-state>
  <p zero-state-title translate="lti-default-error-title" [translateParams]="translationParams"></p>
  <p zero-state-subtext [innerHTML]="'lti-deprecated-launch' | translate:{issues: errors.deprecatedLaunch.join(', ')}">
  </p>
  <div zero-state-body>
    <div class="action-wrapper">
      @if (setupInstructionsLink) {
        <a
          href="{{setupInstructionsLink}}"
          target="_blank"
          class="primary-btn stacked-item"
          translate="lti-deprecated-launch-instruction-button">
        </a>
      }
    </div>
  </div>
  <div zero-state-graphic-bottom>
    <img [src]="activeBrandService.getImage('crashed-astronaut.svg')" alt="No Results">
  </div>
</ngx-zero-state>
